export enum MandantEnum {
  DVAG = "DVAG",
  ALLFINANZ = "ALLFINANZ",
  ALLFINANZ_AG = "ALLFINANZ_AG",
}
